











import { Vue, Component } from 'vue-property-decorator'
import { PublicClientApplication } from '@azure/msal-browser'
import api from 'src/assets/api/rest'
import { signIn } from 'src/boot/auth'

import jwtDecode from 'jwt-decode'

@Component
export default class AzureSignIn extends Vue {
  loading: boolean = false
  error: boolean = false

  async signIn () {
    this.loading = true
    try {
      const azureConfig = {
        auth: {
          clientId: process.env.AZURE_CLIENT_ID || '',
          redirectUri: process.env.VUE_ROUTER_BASE + 'auth'
        }
      }
      const azure = new PublicClientApplication(azureConfig)
      const loginRequest = {
        scopes: ['openid', 'email', 'profile', 'User.Read']
      }
      const loginResponse = await azure.loginPopup(loginRequest)
      if (loginResponse) {

        const token = loginResponse.idToken
        let name = ''
        let locale = ''

        try {
          const headers = { Authorization: `Bearer ${loginResponse.accessToken}` }
          const response = await fetch('https://graph.microsoft.com/v1.0/me/', { headers });
          const data = await response.json()
          name = data.displayName || ''
          locale = (data.preferredLanguage || '').split('-')[0] || this.$i18n.locale
        } catch (e) {}

        const response = await api.post('/api/sign-in/azure', { token, name, locale })
        const accessToken = await response.text()
        signIn(accessToken)
        this.$emit('signin')

      } else {
        this.$emit('error')
      }
    } catch (e) {
      this.$emit('error')
    }
    this.loading = false
  }
}
